import { render, staticRenderFns } from "./CashierTotals.vue?vue&type=template&id=0fbe0e10&scoped=true&"
import script from "./CashierTotals.vue?vue&type=script&lang=js&"
export * from "./CashierTotals.vue?vue&type=script&lang=js&"
import style0 from "./CashierTotals.vue?vue&type=style&index=0&id=0fbe0e10&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe0e10",
  null
  
)

export default component.exports